/**
 * Main JS file for the project
 */

import initBase from './layout/base.js';
import initNavToggle from './layout/navToggle.js';
import initAccordion from './modules/accordion.js';
import initDropdown from './modules/dropdown.js';
import initPropertiesMap from './modules/properties-map.js';
import animateShowInViewport from './layout/animations.js';
import initLightbox from './modules/lightbox.js';
import initInfiniteScroll from './modules/infinite-scroll.js';

document.addEventListener('DOMContentLoaded', () => {
	initBase();
	initNavToggle();
	initAccordion();
	initDropdown();
	initPropertiesMap();
	animateShowInViewport();
	initLightbox();
	initInfiniteScroll();
});